import React from 'react';
import PropTypes from 'prop-types';
import FormattedAddress from '../../../sections/shop/FormattedAddress';
import AddressProp from '../../propTypes/addressProp';
import translate from '../../translate';

const PaymentByCompanyInfo = ({ t, companyBilling }) => {
  const { name, emails, vatNumber, phone, address } = companyBilling;

  const renderItem = (value, label) => (
    <div className="container">
      <span className="title">{label}</span>
      <span className="value">{value}</span>
    </div>
  );
  return (
    <div className="paid-by-company-info">
      <div className="container">
        <span className="title">{t('email.person.responsible')}</span>
        {[...emails]?.length > 0 && [...emails].map(e => <span key={e} className="value">{e || ''}</span>)}
      </div>
      {name && name.length > 0 && (
        renderItem(name, t('profile_companyName'))
      )}
      {phone && phone.length > 0 && (
        renderItem(phone, t('billing_phone'))
      )}
      {vatNumber && vatNumber.length > 0 && (
        renderItem(vatNumber, t('profile_NIF'))
      )}
      <div className="container">
        <span className="title">{t('shop.order.pay.address')}</span>
        <FormattedAddress address={address} containerClass="value" />
      </div>
    </div>
  );
};

PaymentByCompanyInfo.propTypes = {
  t: PropTypes.func.isRequired,
  companyBilling: PropTypes.shape({
    name: PropTypes.string,
    emails: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    email: PropTypes.string,
    taxCode: PropTypes.string,
    phone: PropTypes.string,
    taxType: PropTypes.string,
    vatNumber: PropTypes.string,
    address: PropTypes.shape(AddressProp.propType),
  }).isRequired,
};

export default translate(PaymentByCompanyInfo);
